var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Google(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.632,
    height: 20.632,
    viewBox: "0 0 20.632 20.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffc107;}.b{fill:#ff3d00;}.c{fill:#4caf50;}.d{fill:#1976d2;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.431,12.3H23.6v-.043H14.316v4.126h5.83a6.194,6.194,0,1,1-1.724-6.685L21.34,6.776a10.305,10.305,0,1,0,3.292,7.54A10.386,10.386,0,0,0,24.431,12.3Z",
    transform: "translate(-4 -4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.306,9.514,9.7,12a6.177,6.177,0,0,1,9.843-2.306l2.918-2.918A10.3,10.3,0,0,0,6.306,9.514Z",
    transform: "translate(-5.117 -4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M15.379,36.279A10.268,10.268,0,0,0,22.3,33.6L19.1,30.9a6.174,6.174,0,0,1-9.543-2.845L6.195,30.646A10.308,10.308,0,0,0,15.379,36.279Z",
    transform: "translate(-5.063 -15.647)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M34.115,20.043h-.831V20H24v4.126h5.83A6.21,6.21,0,0,1,27.722,27h0l3.193,2.7a9.979,9.979,0,0,0,3.4-7.637A10.386,10.386,0,0,0,34.115,20.043Z",
    transform: "translate(-13.684 -11.747)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Google);
export default __webpack_public_path__ + "static/media/icons8-google.e780b0456f21f58332813547d6471dee.svg";
export { ForwardRef as ReactComponent };